import { createApiClient } from "@nutrayan/api-client";
import { getEnv } from "./env";
import { useAuth } from "./auth";

const env = getEnv();

// Same-origin by default: the Vite dev proxy (and the production reverse proxy)
// forwards /api and /admin/api to the backend, so no CORS and no env required.
const baseUrl =
  env.VITE_API_BASE_URL ?? (typeof window !== "undefined" ? window.location.origin : "");

export const apiClient = createApiClient({
  baseUrl,
  tenantCode: env.VITE_DEFAULT_TENANT_CODE,
  defaultLocale: "en-IN",
  getAuthToken: () => useAuth.getState().token ?? undefined,
});
